/** Typed calls for the MCP page and consent screen. Shapes mirror apps/api/src/assistant-mcp-routes.ts. */

import { apiCall, orgPath } from '../../api.ts';

export interface McpConnection {
  app_id: string;
  app_name: string;
  client_id: string;
  client_name: string;
  connected_at: string;
  last_refreshed_at: string;
}

const path = (org: string, rest: string) => orgPath(org, `/assistant/mcp${rest}`);

export const mcpApi = {
  connections: (org: string) =>
    apiCall<{ connections: McpConnection[] }>(path(org, '/connections')).then(
      (data) => data.connections,
    ),
  disconnect: (org: string, appId: string, clientId: string) =>
    apiCall<{ connections: McpConnection[] }>(path(org, `/connections/${appId}/${clientId}`), {
      method: 'DELETE',
    }).then((data) => data.connections),
  describe: (org: string, query: string) =>
    apiCall<{ app_name: string; redirect_host: string }>(path(org, `/authorize?${query}`)),
  approve: (org: string, request: Record<string, string>, clientId: string) =>
    apiCall<{ redirect: string }>(path(org, '/authorize'), {
      method: 'POST',
      body: JSON.stringify({ request, client_id: clientId }),
    }),
};

/** The OAuth request an app sent, when the page was opened as a consent screen. */
export function consentQuery(): string | null {
  const match = /^#\/mcp\/authorize\?(.+)$/.exec(window.location.hash);
  return match?.[1] ?? null;
}
